import React from 'react';
import { NavLink } from 'react-router-dom';
import { FormattedMessage } from 'react-intl';
import PropTypes from 'prop-types';

/**
 * 应用下载区域组件
 * @param {Object} props - 组件属性
 * @param {boolean} props.isAir - 是否是空气应用
 * @param {string} props.iosDownloadUrl - iOS下载链接
 * @param {string} props.androidDownloadUrl - 安卓下载链接
 * @param {string} props.googlePlayUrl - Google Play下载链接
 * @param {string} props.locale - 当前语言
 * @param {boolean} props.showQrCode - 是否显示二维码
 * @param {function} props.onQrCodeClick - 二维码点击事件
 */
const AppDownloadArea = ({
  isAir,
  iosDownloadUrl,
  androidDownloadUrl,
  googlePlayUrl,
  locale,
  showQrCode,
  onQrCodeClick,
  styles
}) => {
  const getIosClassName = () => {
    if (locale.indexOf('US') > -1) return styles.ios_en;
    if (locale.indexOf('TW') > -1) return styles.ios_tw;
    return styles.ios;
  };

  const getAndroidClassName = () => {
    if (locale.indexOf('US') > -1) return styles.android_en;
    if (locale.indexOf('TW') > -1) return styles.android_tw;
    return styles.android;
  };

  return (
    <div className={styles.airSecondBox}>
      <div className={isAir ? styles.airLogo : styles.magpieLogo}>
        <NavLink to={isAir ? '/plus' : '/lee-guitars/app'}>
          <i />
          <FormattedMessage id={isAir ? 'cleargass_app' : 'cg_magpie'} />
        </NavLink>
      </div>
      <div className={styles.airRightMenu}>
        <div className={getIosClassName()}>
          <a href={iosDownloadUrl} target="_blank" rel="noopener noreferrer">
            <i />
          </a>
        </div>
        <div className={getAndroidClassName()}>
          <a href={androidDownloadUrl} target="_blank" rel="noopener noreferrer">
            <i />
          </a>
        </div>
        <div className={styles.google}>
          <a href={googlePlayUrl} target="_blank" rel="noopener noreferrer">
            <i />
          </a>
        </div>
        <div className={styles.wechat}>
          <div className={showQrCode ? styles.bg : styles.hide} />
          <div className={isAir ? styles.qrcode : styles.magpieCode} />
        </div>
      </div>
    </div>
  );
};

AppDownloadArea.propTypes = {
  isAir: PropTypes.bool.isRequired,
  iosDownloadUrl: PropTypes.string.isRequired,
  androidDownloadUrl: PropTypes.string.isRequired,
  googlePlayUrl: PropTypes.string.isRequired,
  locale: PropTypes.string.isRequired,
  showQrCode: PropTypes.bool,
  onQrCodeClick: PropTypes.func,
  styles: PropTypes.object.isRequired
};

export default AppDownloadArea; 